import configExcludeDialog from "assets/configExcludeDialog.svg";
import { SBBox, SBTypography } from "modules/Commons";
import SBConfirmDialog from "modules/Commons/SBForms/SBConfirmDialog";
import { useTranslation } from "react-i18next";

export default ({ open, onClose, countOfItems, onConfirm, onCancel }: any) => {
	const { t } = useTranslation();
	return (
		<SBConfirmDialog
			key={open}
			open={open}
			title={t("exclude")}
			onConfirm={onConfirm}
			onCancel={onCancel}
			onClose={onClose}
			confirmColor="error"
		>
			<SBBox display="flex" flexDirection="column" width="25rem">
				<SBBox mx="auto">
					<img
						height={140}
						width={250.14}
						src={configExcludeDialog}
					/>
				</SBBox>
				<SBTypography mt="1.5rem" color="blackTitle.main">
					{t("deleteItemsFromSystem", { itemsCount: countOfItems })}
				</SBTypography>
			</SBBox>
		</SBConfirmDialog>
	);
};
